function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-col">
          <h3>Sibora Global</h3>
          <p>Global Reach. Complete Solutions.</p>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <p>Tax & Accounting</p>
          <p>E-Commerce</p>
          <p>Web Development</p>
          <p>Consulting</p>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <p>About Us</p>
          <p>Careers</p>
          <p>Privacy Policy</p>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <p>info@siboraglobal.com</p>
          <p>+1 (000) 000-0000</p>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Sibora Global. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;